import { AlignHorizontalCenterRounded, AnimationRounded, AspectRatioRounded, FormatColorFillRounded, FormatColorTextRounded, ModeEditRounded, OpenInFullRounded, PaletteRounded, SmartButtonRounded, TextFieldsRounded, TouchAppRounded, VignetteRounded, VisibilityRounded } from "@mui/icons-material";

const iconSX = {

}

const STRINGS = {

    SOMETHING_WENT_WRONG: 'Something went wrong',

    SITE_BUILDER: {

        TEXT_EDITOR: {

            TEXT_CONTENT: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Change text',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            TEXT_STYLE: {

                ICON: <TextFieldsRounded sx={iconSX} />,
                TITLE: 'Text style',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            TEXT_COLOR: {

                ICON: <FormatColorTextRounded sx={iconSX} />,
                TITLE: 'Text color',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            TEXT_ALIGNMENT: {

                ICON: <AlignHorizontalCenterRounded sx={iconSX} />,
                TITLE: 'Textalignment',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            TEXT_ANIMATION: {

                ICON: <AnimationRounded sx={iconSX} />,
                TITLE: 'Text animation',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

        },

        BUTTON_EDITOR: {

            BUTTON_CONTENT: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Button label',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            BUTTON_ACTION: {

                ICON: <TouchAppRounded sx={iconSX} />,
                TITLE: 'Button click',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            BUTTON_TYPE: {

                ICON: <SmartButtonRounded sx={iconSX} />,
                TITLE: 'Button type',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            BUTTON_COLOR: {

                ICON: <FormatColorFillRounded sx={iconSX} />,
                TITLE: 'Button color',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            BUTTON_SIZE: {

                ICON: <AspectRatioRounded sx={iconSX} />,
                TITLE: 'Button size',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

        },

        ICON_EDITOR: {

            CHANGE_ICON: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Change icon',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            ICON_COLOR: {

                ICON: <PaletteRounded sx={iconSX} />,
                TITLE: 'Icon color',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            ICON_SIZE: {

                ICON: <OpenInFullRounded sx={iconSX} />,
                TITLE: 'Icon size',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

        },

        POPOVER_EDITOR: {

            CHANGE_ICON: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Change icon',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            VARIANT: {

                ICON: <SmartButtonRounded sx={iconSX} />,
                TITLE: 'Variant',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },

            CHANGE_LABEL: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Change button label',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            },


        },

        VISIBILITY: {

            ICON: <VisibilityRounded sx={iconSX} />,
            TITLE: 'Visible',
            DESCRIPTION: 'Change your text here',
            HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

        },

        BORDER_RADIUS: {

            ICON: <VignetteRounded sx={iconSX} />,
            TITLE: 'Border radius',
            DESCRIPTION: 'Change border radius here',
            HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

        },

        PROGRAM_LISTING_EDITOR: {

            SELECT_PROGRAMS: {

                ICON: <ModeEditRounded sx={iconSX} />,
                TITLE: 'Change icon',
                DESCRIPTION: 'Change your text here',
                HELPER_TEXT: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'

            }

        },

    }

};

export { STRINGS }